/* eslint-disable import/no-extraneous-dependencies */
import { from } from 'rxjs';
import { map } from 'rxjs/operators';
import {
  CoralResponse,
  CoralInterceptor,
  CoralRequest,
  CoralHandler,
} from '@amzn/ihm-js-coral-client';
import getCSRFToken from '@amzn/carrierlogistics-commons/dist/utils/csrf';
import { RequestInitHeaders } from '@amzn/ihm-js-coral-client/dist/umd/common/headers';
import { CSRF_TOKEN_ID } from '@amzn/carrierlogistics-commons/dist/constants/index';

/*
 * This class is used during client construction, and helps to
 * intercept the headers during request handling for the passport external App.
 */
class RequestOptionsInterceptorForCarrierLogistics extends CoralInterceptor {
  constructor(bindings = {}) {
    super();
    this.bindings = bindings;
  }

  /**
   * @param {CoralRequest} request
   * @param {CoralHandler} next
   * @returns
   */
  // eslint-disable-next-line class-methods-use-this
  intercept(request: CoralRequest, next: CoralHandler) {
    // Adding required header
    const headers: RequestInitHeaders = [
      ['Accept', 'application/json'],
      ['Content-Type', 'application/json'],
      [CSRF_TOKEN_ID, getCSRFToken()],
    ];

    const modifiedRequest = request.clone({
      headers,
      credentials: 'same-origin',
    });
    return from(next.handle(modifiedRequest)).pipe(
      map((response) => {
        const { headers: responseHeaders } = response;
        return new CoralResponse(response);
      })
    );
  }
}

export default RequestOptionsInterceptorForCarrierLogistics;
